import { render } from "./userAddMoneyBatch.vue?vue&type=template&id=0565879a&scoped=true"
import script from "./userAddMoneyBatch.vue?vue&type=script&lang=js"
export * from "./userAddMoneyBatch.vue?vue&type=script&lang=js"

import "./userAddMoneyBatch.vue?vue&type=style&index=0&id=0565879a&scoped=true&lang=css"

import exportComponent from "G:\\phpstudy_pro\\WWW\\xsr SYETEM\\vue-webagent\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0565879a"]])

export default __exports__